module.exports = __webpack_public_path__ + "img/withdraw.180f366f.jpg";